export class SetShiftUserViewStatus {
    public static readonly type = '[JobsPlacements] Set shift user view status';

    constructor(public shiftId: number) {}
}
